import { Injectable } from '@angular/core';
import { AbstractStateService } from '@tnq/shared/core';
import { situationSchema, ISituationState } from '../schemas';

@Injectable({
  providedIn: 'root',
})
export class SituationStateService extends AbstractStateService<ISituationState> {
  protected storageKey = 'tnq-customer-situation';
  protected schema = situationSchema;
}
